// Angular imports
import { enableProdMode } from '@angular/core';
import * as Sentry from '@sentry/angular';
// Constant imports
import { RELEASE } from './assets/release';
import { environment } from './environments/environment';
import * as __NgCli_bootstrap_1 from "./app/app.module.ngfactory";
import * as __NgCli_bootstrap_2 from "@angular/platform-browser";
Sentry.init({
    dsn: environment.sentryDsnUrl,
    environment: environment.name,
    release: RELEASE.version,
    tracesSampleRate: environment.sentryTracesSampleRate,
    beforeSend(event, hint) {
        // Check originalException in hint for specific error patterns
        // Our server-error.service.ts creates actual Error objects which appear in originalException
        if (hint && hint.originalException instanceof Error) {
            const errorMessage = hint.originalException.message;
            // Check for browser notification errors (Object Not Found errors)
            // These come from CefSharp browser notifications and can be safely filtered
            const objectNotFoundPattern = /[\s\S]*Object Not Found Matching Id:\d+, MethodName:[^,]+, ParamCount:\d+[\s\S]*/;
            if (objectNotFoundPattern.test(errorMessage)) {
                return null;
            }
            // Check for timeout errors that were wrapped in Error objects
            // The message might include additional details like "(u)" after "Timeout"
            if (errorMessage.includes('Unhandled promise rejection: Timeout')) {
                return null;
            }
        }
        // Fallback: Check breadcrumbs for Recaptcha timeout rejections
        // When a Promise is rejected with a non-Error value (like 'Timeout' or 'Timeout (u)'),
        // the original rejection reason is stored in the breadcrumb's data before being
        // wrapped in a generic Error object. This gives us access to the raw rejection value.
        const breadcrumbs = event.breadcrumbs || [];
        const hasTimeoutRejection = breadcrumbs.some((crumb) => crumb.category === 'unhandled-rejection' &&
            crumb.data &&
            typeof crumb.data.rejectionReason === 'string' &&
            crumb.data.rejectionReason.includes('Timeout'));
        if (hasTimeoutRejection) {
            return null;
        }
        return event;
    }
});
if (environment.production) {
    enableProdMode();
}
__NgCli_bootstrap_2.platformBrowser()
    .bootstrapModuleFactory(__NgCli_bootstrap_1.AppModuleNgFactory)
    .catch((err) => console.error(err));
